function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Attention as AttentionCircle, CheckOne as CheckCircle, CloseOne as CloseCircle, CloseSmall, Info as InfoCircle } from '../../common/icons';
import { useChildrenEnterLeave } from '../../hooks/animation';
var IconMap = {
  info: InfoCircle,
  error: CloseCircle,
  warning: AttentionCircle,
  success: CheckCircle
};
export function Info(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'info' : _props$type,
      className = props.className,
      _props$show = props.show,
      show = _props$show === void 0 ? true : _props$show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      title = props.title,
      content = props.content,
      icon = props.icon,
      showIcon = props.showIcon,
      hasClose = props.hasClose,
      onClose = props.onClose,
      disableAnimation = props.disableAnimation,
      afterClose = props.afterClose,
      extra = _objectWithoutProperties(props, ["type", "className", "show", "size", "title", "content", "icon", "showIcon", "hasClose", "onClose", "disableAnimation", "afterClose"]);

  var cls = classnames(usePrefixCls('info', {
    size: size,
    type: type
  }), className);
  var bodyCls = usePrefixCls('info-body', {
    'has-icon': showIcon
  });
  var closeCls = usePrefixCls('info-body-close');
  var titleCls = usePrefixCls('info-body-title');
  var iconCls = usePrefixCls('info-body-icon');
  var contentCls = usePrefixCls('info-body-content');
  var iconNode = null;

  if (showIcon) {
    if (icon) {
      iconNode = icon;
    } else if (type && IconMap[type]) {
      var Comp = IconMap[type];
      iconNode = React.createElement(Comp, {
        theme: "filled"
      });
    } else {
      iconNode = null;
    }
  }

  iconNode = iconNode && React.createElement("span", {
    className: iconCls
  }, iconNode);
  var closeNode = hasClose ? React.createElement("span", {
    className: closeCls,
    onClick: onClose
  }, React.createElement(CloseSmall, null)) : null;
  var titleNode = title ? React.createElement("div", {
    className: titleCls
  }, title) : null;
  var contentNode = content ? React.createElement("div", {
    className: contentCls
  }, content) : null;
  var child = show && React.createElement("div", Object.assign({}, extra, {
    className: cls,
    key: "info"
  }), React.createElement("div", {
    className: bodyCls
  }, iconNode, closeNode, titleNode, contentNode));

  var _useChildrenEnterLeav = useChildrenEnterLeave(child, {
    enterTick: enterTick,
    leaveTick: leaveTick,
    duration: 200,
    disabled: disableAnimation,
    onFrameAnimationEnd: afterClose,
    enterChildProps: function enterChildProps(props) {
      return {
        style: _objectSpread(_objectSpread({}, props.style), {}, {
          opacity: 0
        })
      };
    }
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChild = _useChildrenEnterLeav2[0],
      start = _useChildrenEnterLeav2[1];

  useEffect(start);
  return React.createElement(React.Fragment, null, animatedChild);
}

function enterTick(domNode, percent, memo) {
  if (percent >= 1) {
    domNode.style.removeProperty('margin-top');
    domNode.style.removeProperty('opacity');
    return memo;
  }

  var height = memo || domNode.getBoundingClientRect().height;

  if (height) {
    domNode.style.setProperty('opacity', "".concat(percent));
    domNode.style.setProperty('margin-top', "".concat(height * (percent - 1), "px"));
  }

  return height;
}

function leaveTick(domNode, percent, memo) {
  if (percent >= 1) {
    return memo;
  }

  var height = memo || domNode.getBoundingClientRect().height;

  if (height) {
    domNode.style.setProperty('opacity', "".concat(1 - percent));
    domNode.style.setProperty('margin-top', "".concat(height * (0 - percent), "px"));
  }

  return height;
}